import type { zoomError } from '@lib/zoom-helpers/types';

type ZoomErrorCodes = Record<number | string, zoomError>;

export const ZOOM_ERROR_CODES: ZoomErrorCodes = {
  3707: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'The meeting number is not found.',
    errorCode: 3707,
    message: 'Zoom reported a connection error: The meeting number is not found.',
    helpUrl: 'https://help.streamalive.com/en/articles/8038819-why-won-t-streamalive-connect-to-my-zoom-meeting',
    webMessage: 'Zoom reported a connection error: The meeting number is not found.',
    webHelpUrl: 'https://help.streamalive.com/en/articles/8038819-why-won-t-streamalive-connect-to-my-zoom-meeting'
  },
  3009: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'Be removed.',
    errorCode: 3009,
    message: 'Zoom reported a connection error: The bot may have been manually removed. Learn more here.',
    helpUrl: 'https://help.streamalive.com/en/articles/9735597-why-am-i-getting-a-zoom-connection-error',
    webMessage: 'Zoom reported a connection error: The bot may have been manually removed. Please refresh your browser and reconnect.',
    webHelpUrl: ''
  },
  3051: {
    type: 'JOIN_MEETING_FAILED',
    reason: 'Require login',
    errorCode: 3051,
    message: 'StreamAlive does not currently support meetings which require registration or authentication. Please update your meeting settings to use StreamAlive.',
    helpUrl: 'https://help.streamalive.com/en/articles/8038819-why-won-t-streamalive-connect-to-my-zoom-meeting'
  }
};
